// extracted by mini-css-extract-plugin
export var columnItem = "_bs-3";
export var columnItemDraggable = "_bs-4";
export var dragHandle = "_bs-0";
export var dragHandleHovered = "_bs-1";
export var dropdown = "_bs-5";
export var dropdownContent = "_bs-7";
export var dropdownInner = "_bs-6";
export var filterDropdownHeader = "_bs-8";
export var icon = "_bs-2";
export var sectionDivider = "_bs-9";